var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLifeAndPeopleAnimal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-2352.000000, -504.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Life-and-people/Animal",
    transform: "translate(2352.000000, 504.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,10.9917941 L15,4.99726472 C15,3.3417755 13.657,2 12,2 C10.343,2 9,3.3417755 9,4.99726472 L9,10.9917941 C9,12.6472834 10.343,13.9890589 12,13.9890589 C13.657,13.9890589 15,12.6472834 15,10.9917941 M24,10.9917941 L24,4.99726472 C24,3.3417755 22.657,2 21,2 C19.343,2 18,3.3417755 18,4.99726472 L18,10.9917941 C18,12.6472834 19.343,13.9890589 21,13.9890589 C22.657,13.9890589 24,12.6472834 24,10.9917941 M7,16.9863236 L7,12.9899706 C7,11.3344814 5.657,9.99270591 4,9.99270591 C2.343,9.99270591 1,11.3344814 1,12.9899706 L1,16.9863236 C1,18.6418128 2.343,19.9835883 4,19.9835883 C5.657,19.9835883 7,18.6418128 7,16.9863236 M32,16.9863236 L32,12.9899706 C32,11.3344814 30.657,9.99270591 29,9.99270591 C27.343,9.99270591 26,11.3344814 26,12.9899706 L26,16.9863236 C26,18.6418128 27.343,19.9835883 29,19.9835883 C30.657,19.9835883 32,18.6418128 32,16.9863236 M6.001,30.9885453 L6.001,30.9735589 C5.917,25.3976475 9.101,20.0545236 14.488,17.6856854 C15.15,17.3939516 15.824,17.1701558 16.5,16.9863236 C17.177,17.1701558 17.85,17.3939516 18.512,17.6856854 C23.899,20.0545236 27.083,25.3976475 26.998,30.9735589 L26.996,30.9885453 C23.243,31.133413 19.467,29.8995391 16.499,27.5506826 C13.53,29.8995391 9.754,31.133413 6.001,30.9885453",
    id: 51
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeAndPeopleAnimal);
export default __webpack_public_path__ + "static/media/life-and-people-animal.8c602c5b.svg";
export { ForwardRef as ReactComponent };